// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","btnContainer":"App_btnContainer__LNAL3"};